import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner, Box } from '@chakra-ui/react';

/**
 * This route wrapper protects EOS module pages.
 * It grants access *ONLY* if the user has 'isEOSUser: true'
 * SuperAdmin does NOT grant access here.
 */
const EOSUserRoute = ({ children, ...rest }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <Box w="100%" h="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        // --- THIS IS THE KEY LOGIC CHANGE ---
        // It ONLY checks for isEOSUser
        currentUser && currentUser.isEOSUser === true ? (
          <Box
            transform="scale(0.9)"
            transformOrigin="top left"
            w="111.11%"
            sx={{
              '& > .chakra-container': {
                maxWidth: '100%',
              },
            }}
          >
            {children}
          </Box>
        ) : (
          <Redirect
            to={{
              pathname: '/', // Redirect to dashboard
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default EOSUserRoute;

